import React from 'react';
import { PercentageArcs } from '../../components/PercentageArcs';

const titleCase = (txt) => {
  return txt.charAt(0).toUpperCase() + txt.substr(1);
};

export class Genders extends React.Component<any, any> {
  getPercentagesFromAmounts(categories) {
    const total = categories.reduce((accum, val) => {
      return accum + Number(val.total);
    }, 0);

    // const max = categories.reduce((accum, val) => {
    //   return Math.max(val.total, accum);
    // }, 0);

    return categories.map((category) => {
      const percentage = Math.round((Number(category.total) / total) * 100);

      return {
        name: category.name,
        percentage,
      };
    });
  }

  render() {
    const total = this.props.data.reduce((accum, val) => {
      return accum + val.count;
    }, 0);

    const data = this.props.data.map((row) => {
      return {
        name: titleCase(row.name),
        percentage: Math.round((row.count / total) * 100),
      };
    });

    return <PercentageArcs className='h-100-full' title='Gender' data={data} />;
  }
}
